const PERMISSION_KEY= "core:permission_group_user";
const PAGE_URL = {
    PERMISSION_GROUP_USER_PAGE: "/admin/core/permission-group-user"
}

export {PERMISSION_KEY, PAGE_URL}

